$(function() {
  //-------------------------------------
  //  181115 - イラスト訴求枠
  //-------------------------------------
  // var illustGallery = '.js-illust-gallery',
  //     illustLibraryItemInfoTitle = '.js-illust-library-item-info-title';

  // $(illustGallery).slick({
  //   dots: true,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  // });
  // $(illustLibraryItemInfoTitle).tile();

  //-------------------------------------
	//  ページネーションで画面遷移したら作品リストまで移動
	//-------------------------------------
  var arg = {};
  var pair=location.search.substring(1).split('&');
  for(var i=0;pair[i];i++) {
      var kv = pair[i].split('=');
      arg[kv[0]]=kv[1];
  }
  if (arg['page']) {
    // 検索結果上部にスクロール
    $("html,body").animate({
      scrollTop:$('.sort-list').offset().top - $('header').height()
    });
  }

	//-------------------------------------
	//  検索フォーム
	//-------------------------------------
	var searchForm = '.search_form',
		$searchForm = $(searchForm),
		libraryListContentsArea = '#library_list_contents_area',
		moreBtnWrap = '#more_btn_wrap'
		genreSearchActionBtn = '.js-genre-search-action-btn',
		$genreSearchActionBtn = $(genreSearchActionBtn)
		libraryLoaderArea = '#library_loader_area',
    sortListItem = '.js-sort-list-item',
		$sortListItem = $(sortListItem);

    // 高さ合わせ
    $(libraryLoaderArea).find('.js-tile4_2').tile(4);
    $(libraryLoaderArea).find('.js-tile4').tile(4);
    
	// 通常送信はキャンセル
	$searchForm.submit(function(event){
		event.preventDefault();
		return false;
	});

  // フォーム送信
	$genreSearchActionBtn.on('click', function(){
		searchGenreForm(this);
	})

  // ソート
  $sortListItem.on('click' ,function(event){
    event.preventDefault();    
    if ($(this).hasClass('on')) {
      return false;
    }
    $(sortListItem).removeClass('on');
    $(this).addClass('on');
    searchGenreForm(this);
    return false;
  })
  
	function searchGenreForm (btn) {
		// ローディングアニメーション
		$(libraryLoaderArea).hide()
		$(moreBtnWrap).hide()
		$('.loader').css({'padding-bottom':$(libraryLoaderArea).height()}).fadeIn(200);
		if($(btn).is(sortListItem)) {
			// ソート条件で検索
			var data = $(btn).attr('data-params'),
				url = $(btn).attr('data-href'),
        searchUrl = $(btn).attr('data-href') + $(btn).attr('data-params');
        $searchForm.each(function() {
          $(this).attr('action', url);
        });
		}else{
			// フォームの内容で検索
			$(btn).addClass('sending');
			var data = $(btn).parents(searchForm).serialize(),
				url = location.pathname,
				searchUrl = url + '?' + data;
        $sortListItem.each(function() {          
          $(this).attr('data-params', data ? '?'+data : '');
        });
		}

		// Ajax
		$.ajax({
			data: data,
			url: url,
			dataType: "html",
			success: function(data){
				// ブラウザ履歴に残す
				history.pushState(null, null, searchUrl);
				// GAに送る
				ga('send','pageview', searchUrl);

				// ローディングアニメーションを終了、検索結果を入れ替え
				// 検索結果上部にスクロール
				$("html,body").animate({
					scrollTop:$(libraryListContentsArea).offset().top - $('header').height()
				});

				var libraryListContents = $(data).find(libraryListContentsArea);
				libraryListContents.hide();
				$(libraryListContentsArea).replaceWith(libraryListContents);
				$genreSearchActionBtn.removeClass('sending');

				$(libraryListContentsArea).fadeIn(300, function(){
					// いろいろやりすぎでフェードインやスクロールがカクばるのでコールバックで処理（表示件数減らさないとあんまり意味ないけど）
          var observer = lozad('.lazy', {
            loaded: function(el) {
              el.classList.add('is-fade');
            }
          });
          observer.observe();
					// 比較リスト初期化
          if((typeof window.Keep === 'object')){
            Keep.all();
          }
					// 高さ合わせ
					libraryListContents.find('.js-tile4_2').tile(4);
					libraryListContents.find('.js-tile4').tile(4);
				})
			},
		});
	}
});

//-------------------------------------
//  絞り込み検索
//-------------------------------------
$(function() {
  var $checkedDecision = $('.js-checked-decision');

  $checkedDecision.on('click', function(){
    if ($(this).find('input').prop('checked') == true) {
      $(this).addClass('is-active');
    } else {
      $(this).removeClass('is-active');
    }
  });
});

$(function() {
  var allChecked = '.js-all-checked',
      $allChecked = $(allChecked),
      allCheckedCover = '.js-all-checked-cover',
      $allCheckedCover = $('.js-all-checked-cover'),
      checkedDecision = '.js-checked-decision',
      $checkedDecision = $(checkedDecision),
      lineupBox = '.js-lineup-box',
      $lineupBox = $(lineupBox);

  $allChecked.on('click', function() {
    var index = $(this).parents(allCheckedCover).find(allChecked).index(this);
    $(this).parents(allCheckedCover).find('li').removeClass('is-active');
    $(this).addClass('is-active');

    if (index == 0) {
      $(this).parents(allCheckedCover).next().find('input').prop('checked', true);
      $(this).parents(allCheckedCover).next().find('li').addClass('is-active');
    } else {
      $(this).parents(allCheckedCover).next().find('input').prop('checked', false);
      $(this).parents(allCheckedCover).next().find('li').removeClass('is-active');
    }
  });

  $checkedDecision.on('click', function() {
    if ($(this).find('input').prop('checked') == true) {
      $(this).parents(lineupBox).prev().find(allChecked).removeClass('is-active');
    }

    if ($(this).parents(lineupBox).find('input:checked').length == 0) {
      $(this).parents(lineupBox).prev().find(allChecked).eq(1).addClass('is-active');
    }
  });
})